module.exports = __webpack_public_path__ + "static/media/restart.17067dc6.svg";